module.exports = __webpack_public_path__ + "static/img/C.8d3383f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/C.png
// module id = jcKN
// module chunks = 0